<template>
  <div>
    <!-- 根部导航 -->
    <div class="">
      <div class="bar font-size-none">
        <!-- <img class="bg-img" src="../assets/icon-barbg.png" /> -->
        <div class="bar-t width">
          <div class="catalog flex align-center cate" v-if="cates.length">
            <img src="../assets/head/icon-cate-book.png" />
            <div class="space"></div>
            <div class="content flex align-center">
              <div v-for="(item, index) in cates" class="item flex flex-center" :key="item.Id" @click="push(index)" @mouseleave="mouseleavecate()" @mouseenter="mouseentercate(item.Id)">
                <p class="value font-size-18 text-center font-color-ff" :class="item.Id == curr_id || item.Id == cate_cross_id?'text-sel':''">{{ item.CatalogName }}</p>
                <div v-if="item.Id == curr_id || item.Id == cate_cross_id" class='sel'></div>
              </div>
            </div>
          </div>


            <div class="age flex align-center cate" v-if="agesCates.length">
            <img src="../assets/head/icon-cate-age.png" />
            <div class="space"></div>
            <div class="content flex align-center">
              <div v-for="(item, index) in agesCates" class="item flex flex-center" :key="item.Id" @click="ageFilter(index)" @mouseleave="mouseleaveage()" @mouseenter="mouseenterage(item.Id)">
                <p class="value font-size-18 text-center font-color-ff" :class="item.Id == currAage || item.Id == age_cross_id?'text-sel':''">{{ item.CatalogName }}</p>
                <div v-if="item.Id == currAage || item.Id == age_cross_id" class='sel'></div>
              </div>
            </div>
          </div>
          <!-- <div v-if="cates.length" class="flex align-center">

            <div class="cate-new flex align-center">
              <p class="font-size-16 font-color-ff">按分类</p>
              <p class="line"></p>
            </div>

            <div
              :class="
                item.Id == curr_id
                  ? 'font-size-18 bg-color-ffcb sel bar-itm1'
                  : ' bar-itm font-size-16 none'
              "
              v-for="(item, index) in cates"
              :key="item.Id"
              @click="push(index)"
            >
              {{ item.CatalogName }}
            </div>
          </div> -->
          <!-- <div v-if="agesCates.length" style="margin-left: 0.8rem;" class="flex align-center">
            <div class="cate-new flex align-center">
              <p class="font-size-16 font-color-ff">按年龄</p>
              <p class="line"></p>
            </div>
            <div
              :class="
                item.Id == currAage
                   ? 'font-size-18 bg-color-ffcb sel bar-itm1'
                  : ' bar-itm font-size-16 none'
              "
              v-for="(item, index) in agesCates"
              :key="item.Id"
              @click="ageFilter(index)"
            >
              {{ item.CatalogName }}
            </div>
          </div> -->
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import common from "@/utils/common.js";
export default {
  name: "navigation_bar",
  data() {
    return {
      cates: [],
      inList: false,
      item: {
        Id: 0,
        CatalogName: "首页",
        ParentId: 0,
        Level: 1,
        Order: 1,
        CatalogType: 1,
      },
      curr_id: -1,
      cate_cross_id: -1,
      age_cross_id: -1,

      agesCates: [],

      currAage: -1,
    };
  },
  created() {
    var list = [];
    // list.push(this.item);

    const cateAry = common.cate_fr.filter(
      (item) => item.CatalogType == 1 || item.CatalogType == 2
    );
    const ageAry = common.cate_fr.filter((item) => item.CatalogType == 3);
    list = list.concat(cateAry);
    this.cates = list;
    this.agesCates = ageAry;
  },
  methods: {
    // 参数：_id 点击的分类id g是否为精品乐园的分类点击 精品乐园和首页点击跳转页面和其他分类不同 要区分开
    setCurrId(_id, type = 1, g = false) {
      if (type == 3) {
        this.currAage = _id;
        this.curr_id = -1;
      } else {
        this.curr_id = _id;
        this.currAage = -1;
      }
      this.inList = true;
      if (this.curr_id == 0 || g) {
        this.inList = false;
      }
    },

    currAge(id, sel = flase) {
      console.error(id, sel);
    },

    ageFilter(index) {
      this.curr_id = -1;

      if (this.currAge == index) {
        return;
      }
      const res = this.agesCates[index];
      this.currAage = res.Id;
      if (this.inList == false) {
        this.$router.push({
          name: "list",
          query: { type: res.CatalogType, id: res.Id },
        });
      } else {
        this.$router.replace({
          name: "list",
          query: { type: res.CatalogType, id: res.Id },
        });
        this.$emit("change", { id: res.Id, type: res.CatalogType });
      }
    },

    mouseleavecate() {
      this.cate_cross_id = -1
    },

    mouseentercate(id) {
      this.cate_cross_id = id
    },

     mouseleaveage() {
      this.age_cross_id = -1
    },

    mouseenterage(id) {
      this.age_cross_id = id
    },

    push(index) {
      this.currAage = -1
      let res = this.cates[index];
      if (this.curr_id == res.Id) {
        return;
      }
      // 精品乐园跳转
      // this.curr_id = res.Id;
      if (res.CatalogType == 2) {
        this.$router.push({
          name: "course",
        });
      } else {
        if (res.Id == 0) {
          this.$router.push({
            name: "home",
          });
        } else {
          console.log(this.inList);
          if (this.inList == false) {
            this.$router.push({
              name: "list",
              query: { type: res.CatalogType, id: res.Id },
            });
          } else {
            this.$router.replace({
              name: "list",
              query: { type: res.CatalogType, id: res.Id },
            });
            this.$emit("change", { id: res.Id, type: res.CatalogType });
          }
        }
      }
      // else if (res.CatalogName == '0-3岁') {
      //   this.$router.push({
      //     name: 'three',
      //   })
      // } else if (res.CatalogName == '3-6岁') {
      //   this.$router.push({
      //     name: 'six',
      //   })
      // } else if (res.CatalogName == '6-15岁') {
      //   this.$router.push({
      //     name: 'fifteen',
      //   })
      // } else if (res.CatalogName == '0-3岁') {
      //   this.$router.push({
      //     name: 'three',
      //   })
      // } else if (res.CatalogName == '绘本馆') {
      //   this.$router.push({
      //     name: 'picture',
      //   })
      // } else if (res.CatalogName == '电子书城') {
      //   this.$router.push({
      //     name: 'ebook',
      //   })
      // } else if (res.CatalogName == '阅读指导') {
      //   this.$router.push({
      //     name: 'guide',
      //   })
      // } else if (res.CatalogName == '中小学微课堂') {
      //   this.$router.push({
      //     name: 'microclass',
      //   })
      // } else if (res.CatalogName == '互动乐园') {
      //   this.$router.push({
      //     name: 'playground',
      //   })
      // } else if (res.CatalogName == '家长') {
      //   this.$router.push({
      //     name: 'parent',
      //   })
      // } else if (res.CatalogName == '老师') {
      //   this.$router.push({
      //     name: 'teacher',
      //   })
      // } else if (res.CatalogName == '首页') {
      //   this.$router.push({
      //     name: 'home',
      //   })
      // }
    },
  },
};
</script>

<style scoped>
.bar {
  position: relative;
  height: 0.72rem;
  background-color: #fff;
}

.bar .bg-img {
  width: 100%;
  height: 0.72rem;
}

.bar .bar-t {
  display: flex;
  align-items: center;
  margin: 0 auto;
  height: 0.72rem;
}

.bar .bar-itm {
  height: 0.7rem;
  line-height: 0.7rem;
  text-align: center;
  color: #fff;
  cursor: pointer;
}
.bar .bar-itm1 {
  height: 0.7rem;
  line-height: 0.7rem;
  text-align: center;
  color: #fffc00;
  cursor: pointer;
}
.bar .bar-itm:hover {
  color: #ffcb05;
}
.sel {
  padding: 0 0.12rem;
  font-weight: bold;
}

.none {
  background-color: rgba(0, 0, 0, 0);
  padding: 0 0.14rem;
}

.cate-new .line {
  width: 0.02rem;
  height: 0.16rem;
  background-color: #fff;
  margin-left: 0.16rem;
}

.cate {
  position: relative;
}

.catalog {
  margin-right: 0.2rem;
}

.catalog .space {
  width: 0.88rem;
}

.age .space {
  width: 0.84rem;
}

.cate .content {
  position: relative;
  padding-left: 0.62rem;
  padding-right: 0.12rem;
  background-color: #23cebc;
  border-radius: 0.1rem 0.1rem 0 0;
  height: 0.72rem;
}

.cate img {
  width: 1.5rem;
  height: 1.08rem;
  position: absolute;
  left: 0;
  z-index: 2;
}

.age .content .item {
  position: relative;
  width: 0.82rem;
  height: 0.72rem;
  padding: 0 0.1rem;
  cursor: pointer;
}

.catalog .content .item {
  position: relative;
  width: 0.8rem;
  height: 0.72rem;
  padding: 0 0.16rem;
  cursor: pointer;
}

.cate .content .item .value {
  z-index: 3;
  text-shadow: 0px 2px 1px #29BBA4;
  font-family: fz-font-custom;
}

.cate .content .item .sel {
  position: absolute;
  width: 0.8rem;
  height: 0.82rem;
  background-color: #FBB03B;
  z-index: 2;
  left: 0;
  bottom: 0;
  border-radius: 0.1rem 0.1rem 0 0;
}

.cate .content .item .text-sel {
  font-size: 0.22rem;
  line-height: 0.26rem;
  text-shadow: 0px 0.02rem 0.01rem #F99525;

}
</style>


// WEBPACK FOOTER //
// src/components/navigation_bar.vue